module.exports = __webpack_public_path__ + "img/booked_icon.ec5d3284.svg";